/* eslint-disable*/

import { Box, Typography } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import {
  amazon_100items,
  rakuten_100items,
  yahoo_100items
} from 'feactures/brand/brandRankSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import BrandItemList from './BranditemList';

const BrandItemTable = (props) => {
  const { yokoziku } = props;
  const a_100items = useSelector(amazon_100items);
  const r_100items = useSelector(rakuten_100items);
  const y_100items = useSelector(yahoo_100items);
  const channel = useSelector(currentchannel);

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography fontSize="14px" fontWeight="bold">
          TOP100商品
        </Typography>
      </Box>

      {channel == 1 ? (
        <BrandItemList
          top100items={a_100items !== [] ? a_100items : []}
          yokoziku={yokoziku}
          section="競合"
        />
      ) : null}
      {channel == 2 ? (
        <BrandItemList
          top100items={r_100items !== [] ? r_100items : []}
          yokoziku={yokoziku}
          section="競合"
        />
      ) : null}
      {channel == 3 ? (
        <BrandItemList
          top100items={y_100items !== [] ? y_100items : []}
          yokoziku={yokoziku}
          section="競合"
        />
      ) : null}
    </Box>
  );
};

export default BrandItemTable;
